<template>
  <div class="flex flex-col md:flex-row h-screen w-full pt-16 overflow-y-auto">
    <div class="flex flex-col md:w-2/6 pt-4 items-center border-black px-8">
      <h1 class="font-black mb-2 text-xl text-teal-900">Entities Config</h1>
      <div class="border-2 h-full w-full mb-2 rounded border-teal-500 height-more overflow-y-auto p-1">
          <entities-list 
            v-for="item in entityList" 
            :key="item.id"
            :background="item.color"
            :value="item.name"
            :editText="editText"
            :idx="item.id"
            :checking="checking"></entities-list>
      </div>
      <!-- ADDING NER LIST BUTTON -->
      <div class="flex w-full ">
        <button 
          class="button-plusmin mb-4 mr-1 text-teal-200 w-full h-8 bg-teal-700 focus:outline-none flex items-center justify-center rounded"
          @click="addEntities">
          <i class="fas fa-plus text-xl"></i>
        </button>
        <button 
          class="button-plusmin mb-4 ml-1 text-teal-200 w-full h-8 bg-teal-700 focus:outline-none flex items-center justify-center rounded"
          @click="saveResult">
          SAVE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';

import { baseUrl } from '@/config';
import EntitiesList from '@/components/EntitiesList';
import { colorizer } from '@/helpers';

export default {
  mounted() {
    console.log('mounted');
    this.fetchEntities();
  },
  data() {
    return {
      editing: false,
      entityList: []
    };
  },
  methods: {
    ...mapActions({ updateEntities: 'entities/updateEntities' }),
    ...mapActions({ fetchEntities: 'entities/fetchEntities' }),
    editText(id, text) {
      for (let item of this.entityList) {
        if (item.id === id) {
          item.name = text;
          break
        }
      }
    },
    checking(id, checked) {
      for (let item of this.entityList) {
        if (item.id === id) {
          item.checked = checked;
          break
        }
      }
    },
    addEntities() {
      this.entityList.unshift({
        id: 'APTX-' + Date.now(),
        checked: true,
        name: '',
        color: colorizer()
      })
    },
    saveResult() {
      this.updateEntities(this.entityList);
      axios.post(baseUrl + '/saveEntityList', this.entityList)
      .then(resp => {
        console.log(resp);
      })
      .catch(err => {
        console.log(err);
        console.log(err.message);
      });
    }
  },
  components: {
    EntitiesList
  }
}
</script>

<style>

</style>